import { Alert, Col, Input, InputGroup, Row } from "reactstrap";
import DefaultModal from "./Default";
import DefaultButton from "../Buttons/Default";
import { useState } from "react";
import { API_URL } from "../../utils/constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SubscribeModal({isOpen, toggle, plan}) {
  const { t } = useTranslation('plans');
  const navigate = useNavigate();
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponLoading, setCouponLoading] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [amountToPay, setAmountToPay] = useState(plan?.price || 0);

  const checkStatus = () => {
    const interval = setInterval(async () => {
      try {
        const response = await fetch(API_URL+'/user/subscriptions/status', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await response.json();

        if(data.success) {
          clearInterval(interval);
          setSubscriptionLoading(false);
          toast.success('تم تفعيل اشتراكك بنجاح!');
          toggle();
        }
      } catch (error) {
        toast.error('حدث خطأ أثناء تفعيل اشتراكك. يرجى المحاولة مرة أخرى..');
      }
    }, 10000);
  }

  const subscribe = () => {
    setSubscriptionLoading(true);

    fetch(API_URL+'/user/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ plan_id: plan.id, coupon: couponCode.trim() })
    })
    .then(response => response.json())
    .then(data => {      
      if (data.success) {
        if(!data.url) {
          setSubscriptionLoading(false);
          toast.success('تم تفعيل اشتراكك بنجاح!');
          toggle();
          navigate('/ad_balance');
          return;
        }

        const {url} = data;
        if(window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'open-url', url }));
        } else {
          window.open(url, '_blank');
        }

        checkStatus();
      } else {
        setSubscriptionLoading(false);
        toast.error(data.message || 'حدث خطأ أثناء الاشتراك. يرجى المحاولة مرة أخرى.');
      }
    })
    .catch(error => {
      setSubscriptionLoading(false);
      toast.error('حدث خطأ أثناء الاشتراك. يرجى المحاولة مرة أخرى.');
    });
  }

  const applyCoupon = () => {
    setCouponLoading(true);

    fetch(API_URL+'/user/subscriptions/check-coupon', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ coupon: couponCode.trim() })
    })
    .then(response => response.json())
    .then(data => {
      setCouponLoading(false);
      if (data.success) {
        toast.success('تم تطبيق كود الخصم بنجاح!');
        setAppliedCoupon(data.coupon);
        const discountAmount = (plan.price * data.coupon.percentage) / 100;
        setAmountToPay(plan.price - discountAmount);
      } else {
        toast.error(data.message || 'كود الخصم غير صالح');
      }
    })
    .catch(error => {
      setCouponLoading(false);
      toast.error('حدث خطأ أثناء تطبيق كود الخصم');
    });
  }

  return(
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      title={t('pay.title')}
      size="md"
    >
      <div>
        <h6>{t('pay.price')}</h6>
        <span>{plan?.price} {t('currency')}</span>
      </div>

      <hr />

      <div>
        <h6>{t('pay.payment_method')}</h6>
        <span>{t('pay.knet')}</span>
      </div>

      <hr />

      <div>
        <h6>{t('pay.coupon.label')}</h6>
        <InputGroup>
          <Input 
            type="text" 
            placeholder={t('pay.coupon.placeholder')}
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
          />
          <DefaultButton
            onClick={applyCoupon}
            loading={couponLoading}
            disabled={!couponCode.trim() || couponLoading}
          >
            {t('pay.coupon.apply')}
          </DefaultButton>
        </InputGroup>
      </div>

      {appliedCoupon &&
        <Alert color="success" className="mt-3">
          تم تطبيق كود الخصم: <strong>{appliedCoupon.code}</strong> - خصم <strong>{appliedCoupon.percentage}%</strong>
        </Alert>
      }

      <hr />

      <Row>
        <Col xs="6">
          <span className="text-primary">{t('pay.amount_to_pay')}</span>
        </Col>
        <Col xs="6" className="text-end">
          <span className="text-primary">{amountToPay} {t('currency')}</span>
        </Col>
      </Row>

      <div className="text-center">
        <DefaultButton 
          className='px-4'
          loading={subscriptionLoading}
          onClick={subscribe}
          disabled={subscriptionLoading}
        >
          {t('pay.button')}
        </DefaultButton>
      </div>
    </DefaultModal>
  );
}

export default SubscribeModal;